import { css } from 'emotion';

export const nextPageContainer = css(`
	width: 100%;
	text-align: center;
	margin: 30px auto;
`);
